import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Box } from '@chakra-ui/react';
import Layout from '../../components/Layout';
import InfoSection from '../../components/shared/InfoSection';
import LearnMoreSection from '../../components/shared/LearnMoreSection';
import FeaturedPosts from '../../components/shared/FeaturedPosts';
import TryHoverTodaySection from '../../components/shared/TryHoverTodaySection';
import CustomerQuotesGrid from './CustomerQuotesGrid';
import CustomerSpotlightSection from './CustomerSpotlightSection';
import Hero from './Hero';

const INFO_ITEMS = [
  {
    image: (
      <StaticImage
        style={{ maxWidth: '115px' }}
        src="../../images/engage-smarter-icon.svg"
        alt="Icon Engage smarter"
      />
    ),
    title: 'Engage smarter with carriers',
    description:
      'HOVER’s comprehensive and accurate measurements - from a few smartphone photos - help you communicate project scope more effectively with adjusters throughout the claims process.',
  },
  {
    image: (
      <Box
        minH="115px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <StaticImage
          style={{ maxWidth: '115px' }}
          src="../../images/house-cracked-icon.svg"
          alt="Icon cracked house"
        />
      </Box>
    ),
    title: 'Handle more claims',
    description:
      'Enable your team to gather and submit information quickly and accurately using HOVER’s measurements report and .esx file. Do more with less to maintain profits margins when a storm hits - even when labor is limited.',
  },
  {
    image: (
      <StaticImage
        style={{ maxWidth: '115px' }}
        src="../../images/thumbs-up-icon.png"
        alt="Icon thumbs up"
      />
    ),

    title: 'Build credibility',
    description:
      'Don’t just tell, show. Inspire trust and stand out from the competition by helping homeowners understand their claim packet and select products and colors via an interactive 3D model of their home.',
  },
];

const FEATURED_POSTS = {
  mainPost: {
    image: (
      <StaticImage
        src="../../images/MD-482-BLOG-Digital-Hyve-Blog-Header-1-2.webp"
        alt="Digital marketing Q&A for stormers"
      />
    ),
    title: 'Driving Leads Digitally After a Storm',
    slug: 'driving-leads-digitally-after-a-storm',
    description:
      'Digital marketing best practices for restoration professionals to grow their home improvement businesses during storm season.',
  },
  secondaryPosts: [
    {
      image: (
        <StaticImage
          src="../../images/MD-460-WebinarCreative-GmailSquare-300x300-v2.webp"
          alt="Navigating storm season with HOVER"
        />
      ),
      title: 'Navigating Storm Season with HOVER',
      slug: 'navigating-storm-season-with-hover',
    },
    {
      image: (
        <StaticImage
          src="../../images/blog-image-plan.webp"
          alt="construction drawing"
        />
      ),
      title: 'Best Practices for Restoration Professionals',
      slug: 'best-practices-for-restoration-contractors-during-covid-19',
    },
  ],
};

const index = () => (
  <Layout
    isNavInitiallyTransparent={false}
    title="Restoration Contractors | Exterior Home Improvement"
    description="HOVER's technology can help your home improvement business respond to storms faster and serve your customers more efficiently. Learn more."
  >
    <Hero />
    <InfoSection
      numColumns={3}
      infoItems={INFO_ITEMS}
      sectionTitle="Respond to storms faster and serve your customers more efficiently"
    />
    <LearnMoreSection ctaLink="/transform-plan?utm_source=Website%20Module&utm_medium=0&utm_campaign=Transform%20IMC_Announcement&utm_term=0&utm_content=0_0_0" />
    <CustomerSpotlightSection />
    <CustomerQuotesGrid />
    <FeaturedPosts
      mainPost={FEATURED_POSTS.mainPost}
      secondaryPosts={FEATURED_POSTS.secondaryPosts}
    />
    <TryHoverTodaySection
      title="Connect with us"
      buttonText="Schedule a Call"
      ctaLink="https://calendly.com/hover-sdr/hover-for-restoration-contractors"
      description="Learn more about how HOVER can help your business weather the storm."
    />
  </Layout>
);

export default index;
